export type AuthState = {
  sending: boolean
  loginError: Error | null
  token: string | null
  refreshToken: string | null
  id: number | null
  role: string | null
}

export type AuthSession = {
  token: string
  refreshToken: string
}

export enum LogoutReason {
  ANOTHER_TAB_ENDED_THE_SESSION = 'anotherTabEndedTheSession'
}

export type AuthStore = {
  getState: () => { auth: AuthState }
  dispatch: (action: { type: string; payload?: unknown }) => void
}
